export const CARD_AREA = {
  images: 'images',
  thumbnailImage: 'thumbnailImage',
  primary: 'primary',
  secondary: 'secondary',
  lowestPriceBtn: 'lowestPriceBtn',
  other: 'other',
  goDetail: 'goDetail',
  partnerOffersSection: 'partnerOffersSection',
};
